import { useMemo } from 'react';
import { createEventBus } from '../../emitter';
import { useGlobalAppStateStore } from '../stores/app/GlobalAppStateStore';
import type { InterfaceEventBusType } from '../types/eventBus';

function useInterfaceEventBus() {
  const interfaceId = useGlobalAppStateStore().hooks.record.useId();
  const eventBus = useMemo(() => createEventBus<InterfaceEventBusType>(interfaceId), [interfaceId]);
  return { interfaceEventBus: eventBus };
}

export default useInterfaceEventBus;

export type UseInterfaceEventBusType = ReturnType<typeof useInterfaceEventBus>;
